export enum RejectRequestActionTypes {
    REJECT_REQUEST_START = 'REJECT_REQUEST_START',
    REJECT_REQUEST_SUCCESS = 'REJECT_REQUEST_SUCCESS',
    REJECT_REQUEST_FAILURE = 'REJECT_REQUEST_FAILURE',
};

export interface RejectRequestState {
    isRejected: boolean;
    isDeleting: boolean;
    rejectErrorMessage: string | null;
};

export interface RejectRequestStartPayload {
    messageId: string;
    programmatic: boolean | undefined;
};

export interface RejectRequestSuccessPayload {
    isRejected: boolean
};

export interface RejectRequestFailurePayload {
    errorMessage: string;
};

export type RejectRequestStart = {
    type: typeof RejectRequestActionTypes.REJECT_REQUEST_START;
    payload: RejectRequestStartPayload;
};

export type RejectRequestSuccess = {
    type: typeof RejectRequestActionTypes.REJECT_REQUEST_SUCCESS;
    payload: RejectRequestSuccessPayload;
};

export type RejectRequestFailure = {
    type: typeof RejectRequestActionTypes.REJECT_REQUEST_FAILURE;
    payload: RejectRequestFailurePayload;
};

export type RejectRequestActions =
    | RejectRequestStart
    | RejectRequestSuccess
    | RejectRequestFailure;